var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "₹{{amount_no_decimals}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

if ($("#preloader").length > 0) {
  $(window).on("load", function () {
    $("#preloader").hide();
    $("body").removeClass("preloader-overflow");
  });
}

$(document).ready(function () {
  var Dwin = $(this);
  if (Dwin.width() >= 769) {
    slickVeritcal();
  }
  else {
    slickHorizontal();
  }
});

let lastWidth = $(window).width();
let resizeTimer;

$(window).on('resize', function () {
  const currentWidth = $(window).width();
  // Only trigger if width actually changed (ignore mobile address bar height changes)
  if (currentWidth !== lastWidth) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (currentWidth >= 769) {
        slickVeritcal();
      } else {
        slickHorizontal();
      }
      lastWidth = currentWidth;
    }, 250);
  }
});

function slickVeritcal() {
  if ($(".media-slick-slider  .thumbnail-list").length > 0) {
    $(".thumbnail-list").not(".slick-initialized").slick({
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 4,
      slidesToScroll: 1,
    });

  }
}
function slickHorizontal() {
  if ($(".media-slick-slider  .thumbnail-list").length > 0) {
    $(".thumbnail-list").slick("unslick");
  }
}

let scrollTicking = false;
$(window).on('scroll', function () {
  if (!scrollTicking) {
    window.requestAnimationFrame(() => {
      const scrollTop = $(window).scrollTop();
      const width = $(window).width();
      const limit = width > 1024 ? 500 : 900;

      const footer = $('.tritiya-footer-section');
      const footerTop = footer.length ? footer.offset().top : 0;
      const windowHeight = $(window).height();

      if (scrollTop >= limit && (footerTop === 0 || scrollTop + windowHeight < footerTop - 50)) {
        $(".sticky-bar").addClass("active");
      } else {
        $(".sticky-bar").removeClass("active");
      }
      scrollTicking = false;
    });
    scrollTicking = true;
  }
});

$(document).ready(function () {
  $("#recently").click(function () {
    $("#recently-viewed-products").slideToggle(500);
  });
});

var afterInfiniteLoaded = function afterInfiniteLoaded() {
  $(".loading-image").removeClass("loading-image").addClass("loaded-image");
};
if ($(".pagination-method-loadmore_btn").length > 0) {
  var AjaxMethod = "click";
} else {
  var AjaxMethod = "scroll";
}
if ($(".collection #AjaxinatePagination").length > 0) {
  var endlessScroll = new Ajaxinate({
    container: ".AjaxinateContainer",
    pagination: "#AjaxinatePagination",
    method: AjaxMethod,
    offset: 0,
    callback: afterInfiniteLoaded,
  });
}

InitCustomFunctions();
function InitCustomFunctions() {
  $('.facet-checkbox input:checkbox').each(function () {
    if ($(this).is(':checked')) {
      $(this).parent('.facet-checkbox').addClass('active');
    }
  });



  if ($(".toggleFilter").length > 0) {
    const filter = document.querySelector(".toggleFilter");
    const sidebar = document.querySelector(".facets-vertical");
    const closeDiv = document.querySelector(".close-sidebar");

    filter.addEventListener("click", () => {
      filter.classList.toggle("active");
      sidebar.classList.toggle("open");
      $("body").addClass("overflow-hidden");
      $("body").addClass("filter-clicked");
    });

    closeDiv.addEventListener("click", () => {
      filter.classList.remove("active");
      sidebar.classList.remove("open");
      $("body").removeClass("overflow-hidden");
      $("body").removeClass("filter-clicked");
    });
  }

  //product page color variant to select thumbnail img change color_variants
  if ($(".show-grouped__variant").length > 0) {
    $('input:radio[name="Color"]').click(function () {
      const cvariant = $(this).val();
      $(this).closest('fieldset').find('.form__label span').text(cvariant);
      $('input:radio[name="Color"]')
        .next(".swatch-element")
        .removeClass("clicked");
      $(this).next(".swatch-element").addClass("clicked");
      $(".slick-list").addClass("height_fix");
      $(".thumbnail-list__item").each(function () {
        const variant_val = $(this).find("img").attr("alt");
        if (cvariant == variant_val) {
          $(this).addClass("show");
          $(this).removeClass("hidden");
        } else {
          $(this).addClass("hidden");
          $(this).removeClass("show");
        }
      });
    });
  }

  //     Item swatch trigger start
  $(document).on("click", ".color-values a", function () {
    if ($(this).hasClass("active")) {
      $(this).closest('.variant-option-color').find('.color-values a').removeClass("active");
    } else {
      $(this).closest('.variant-option-color').find('.color-values a').removeClass("active");
      $(this).addClass("active");
    }
  });

  $(document).on("click", ".size-values a", function () {
    if ($(this).hasClass("active")) {
      $(".size-values a").removeClass("active");
      $(this)
        .parents(".products")
        .find(".variant-option-size .size-values")
        .removeClass("active");
    } else {
      $(".size-values a").removeClass("active");
      $(this).addClass("active");
      $(this)
        .parents(".products")
        .find(".variant-option-size .size-values")
        .removeClass("active");
    }
  });
  $("body").on("click", ".color-values-plus a", function (e) {
    $(this)
      .parents(".variant-option-color")
      .find(".show-on-click")
      .css("display", "flex");
    $(this).parents(".color-values-plus").css("display", "none");
    e.preventDefault();
  });

  $("body").on("click", ".swatch-element.color", function () {
    $(this).next("label").find("i");
  });
  $("body").on("click", ".swatch span", function () {
    // Find the specific product card container
    var $productCard = $(this).closest(".card-wrapper, .product-grid-item, .grid__item, .products");
    if ($productCard.length === 0) {
      $productCard = $(this).closest(".product-grid");
    }

    // Update Image
    var $image = $productCard.find(".card__inner .motion-reduce, .featured-image");
    if ($image.length > 0) {
      $image.attr("srcset", $(this).data("image"));
    }

    if ($(this).parents(".swatch").hasClass("color")) {
      const variant = $(this).data("id");
      $productCard.find(".variant-push").val(variant);

      var swatch_item = $(this).data("variant-item");

      $productCard.find(".variant-option-size .size-values").removeClass("active");

      $productCard.find(".variant-option-size .swatch").each(function () {
        var swatch_size_vars = $(this).find("span").data("variant-title");
        if (swatch_size_vars) {
          swatch_size_vars = swatch_size_vars.split("/");
          swatch_size_vars = $.map(swatch_size_vars, $.trim);
          swatch_size_vars = $.map(swatch_size_vars, function (n) {
            return n.toLowerCase();
          });
          swatch_size_vars = $.map(swatch_size_vars, function (n) {
            return n.replace(/ /g, "-");
          });

          if ($.inArray(swatch_item, swatch_size_vars) >= 0) {
            $(this).parent(".size-values").toggleClass("active");
          }
        }
      });
    }

    if ($(this).parents(".swatch").hasClass("size") || $(this).parents(".swatch").hasClass("color")) {
      var variantId = $(this).data("id") || $(this).data("ids");
      var variantPrice = $(this).data("price");
      var variantComparePrice = $(this).data("compare-price");

      var cardInfo = $productCard.find(".card__information");

      // --- Handle Active Highlight ---
      var swatchType = $(this).parents(".swatch").hasClass("size") ? ".variant-option-size" : ".variant-option-color";
      var parentSection = $(this).closest(swatchType);

      parentSection.find(".active").removeClass("active");
      $(this).addClass("active");
      $(this).closest("li").addClass("active");
      // -------------------------------

      // Update variant ID for cart
      $productCard.find(".variant-push").val(variantId);

      if (variantPrice) {
        var moneyFormat = (typeof DT_THEME !== 'undefined' && DT_THEME.moneyFormat) ? DT_THEME.moneyFormat : (Shopify.money_format || "₹{{amount_no_decimals}}");
        var formattedPrice = Shopify.formatMoney(variantPrice, moneyFormat);

        // Update Regular Price
        cardInfo.find(".price-item--regular").each(function () {
          $(this).html(formattedPrice);
        });

        // Update Sale Price
        cardInfo.find(".price-item--sale").each(function () {
          $(this).html(formattedPrice);
        });

        if (variantComparePrice && parseInt(variantComparePrice) > parseInt(variantPrice)) {
          var formattedComparePrice = Shopify.formatMoney(variantComparePrice, moneyFormat);
          cardInfo.find("s.price-item--regular").each(function () {
            $(this).html(formattedComparePrice);
          });
          cardInfo.find(".price").addClass("price--on-sale").removeClass("price--no-compare");

          // Update Discount Percentage Badge
          var discount = Math.round(((variantComparePrice - variantPrice) * 100) / variantComparePrice);
          var badge = $productCard.find(".badge--bottom-left");
          if (badge.length > 0) {
            badge.html(discount + "% OFF").show();
          }
        } else {
          cardInfo.find(".price").removeClass("price--on-sale").addClass("price--no-compare");
          $productCard.find(".badge--bottom-left").hide();
        }
      }
    }
  });

  //     Item swatch trigger end
  $(".custom-product-grid li").click(function () {
    var classNames = "list-view-filter grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop align-1-column align-2-column align-3-column align-4-column align-5-column";
    var getCols = $(this).data("cols");
    var getVal = $(this).data("val");
    var getVal = "align-" + getVal + "-column";
    $(".custom-product-grid li").removeClass("active");
    $(this).addClass("active");
    $("ul#product-grid").removeClass(classNames).addClass(getCols + " " + getVal);
  });
  if ($(".filter-buttons").length > 0) {
    const viewExists = document.querySelector(".grid-view-button");
    if (viewExists.classList.contains("layout-mode")) {
      const listViewButton = document.querySelector(".list-view-button");
      const gridViewButton = document.querySelector(".grid-view-button");
      const list = document.querySelector("ul.view-mode");
      const gridviewlist = document.querySelector(".custom-product-grid");

      listViewButton.onclick = function () {
        listViewButton.classList.add("active");
        gridViewButton.classList.remove("active");
        list.classList.remove("grid-view-filter");
        list.classList.add("list-view-filter");
        gridviewlist.classList.add("hidden");
      };

      gridViewButton.onclick = function () {
        listViewButton.classList.remove("active");
        gridViewButton.classList.add("active");
        list.classList.remove("list-view-filter");
        list.classList.add("grid-view-filter");
        gridviewlist.classList.remove("hidden");
      };
    }
  }
  if ($("#swiper-sidebar-carousel").length > 0) {
    var swiper = new Swiper("#swiper-sidebar-carousel", {
      navigation: {
        nextEl: "#swiper-sidebar-next",
        prevEl: "#swiper-sidebar-prev",
      },
    });
  }

  $(".loading-image").removeClass("loading-image").addClass("loaded-image");

  const radioButtons = document.querySelectorAll('.dt-sort__container input[name="sort_by"]');
  const optionSummary = document.querySelector('.dt-sort__container .facets__summary-label');
  var selectedRadioButton;
  for (const radioButton of radioButtons) {
    if (radioButton.checked) {
      selectedRadioButton = radioButton.getAttribute("data-value");
      optionSummary.innerHTML = selectedRadioButton;
    }
  }

}


//FBT ul li select box
$("ul.custom-select").on("click", "li:not(.init)", function () {
  var selectedVal = $(this).data("option-value");
  $(this)
    .parents(".fbt-product__meta")
    .find(".selectVariant option")
    .attr("selected", false);
  $(this)
    .parents(".fbt-product__meta")
    .find(".selectVariant option[value=" + selectedVal + "]")
    .attr("selected", "selected")
    .trigger("change");
});

$("ul.custom-select").on("click", ".init", function () {
  $(this).closest("ul.custom-select").children("li:not(.init)").toggle();
});

$("ul.custom-select").on("click", "li:not(.init)", function () {
  $(this).parent().children("li:not(.init)").removeClass("selected");
  $(this).addClass("selected");
  $(this).parent().children(".init").html($(this).html());
  $(this).parent().children(".init").removeClass("li-unselected");
  $(this).parent().children("li:not(.init)").toggle();
  if ($("ul.custom-select li.init").hasClass("li-unselected")) {
    $("#add-frequently-bought").prop("disabled", true);
  } else {
    $("#add-frequently-bought").prop("disabled", false);
  }
});
loadedBg();
function loadedBg() {
  $(window).on("load", function () {
    $(".loading-image").removeClass("loading-image").addClass("loaded-image");
  });
}

jQuery(function () {
  jQuery().on("click", function () {
    jQuery("iframe")
      .contents()
      .find("video")
      .each(function () {
        this.currentTime = 0;
        this.pause();
      });
  });
});


document.querySelector(".header-drawer__close").addEventListener("click", closeDrawerMenu);
function closeDrawerMenu() {
  document.querySelector("body").classList.remove("overflow-hidden-tablet");
}

$("#dT_TopStickySearchBtn").click(function (ev) {
  ev.preventDefault();
  $("#dT_top-sticky").addClass("search-show");
  $("#dT_top-sticky .search-modal").css("opacity", "1");
  $("body").addClass("search-overlay-open");
});

$(".dT_TopStickySearchCloseBtn").click(function (ev) {
  ev.preventDefault();
  $("#dT_top-sticky").removeClass("search-show");
  $("#dT_top-sticky .search-modal").css("opacity", "0");
  $("body").removeClass("search-overlay-open");
});

$("#AccessibleNav .sub-menu-block").show();



$(document).ready(function () {
  const mainContent = document.getElementById("MainContent");
  if (mainContent) {
    mainContent.classList.remove("placeholder-shadow-blocks");
  }
});



$(function () {
  $(document).on('click', '.acc__title', function (j) {
    j.preventDefault();
    var dropDown = $(this).next('.dt-sc-tabs-content');
    if (dropDown.length === 0) {
      dropDown = $(this).closest('.dt-sc-tabs-content');
    }

    var $clickedTitle = $(this);
    var isActive = $clickedTitle.hasClass('active');

    // Slide up other active accordions and remove active class from their titles
    var $otherTitles = $clickedTitle.siblings('.acc__title.active');
    $otherTitles.each(function() {
      var $otherTitle = $(this);
      var $otherContent = $otherTitle.next('.dt-sc-tabs-content');
      $otherContent.stop(false, true).slideUp(400, function() {
        $otherTitle.removeClass('active');
      });
    });

    if (isActive) {
      // If it's already active, slide it up and remove the active class after the animation completes
      dropDown.stop(false, true).slideUp(400, function() {
        $clickedTitle.removeClass('active');
      });
    } else {
      // If it's not active, add active class first (so CSS display: block matches), and slide it down
      $clickedTitle.addClass('active');
      dropDown.stop(false, true).slideDown(400);
    }
  });
});


$(document).ready(function () {
  $('.tablinks').click(function () {
    $(".dt-sc-tabs-content").removeClass('tab-active-content');
    $(".dt-sc-tabs-content[data-id='" + $(this).attr('data-id') + "']").addClass("tab-active-content");
    $(".tablinks").removeClass('active-tab');
    $(this).addClass('active-tab');
  });
});


$(document).ready(function () {
  hotSpot();
});
$(window).on("resize", function () {
  hotSpot();
});
function hotSpot() {
  if ($(window).width() > 767) {
    jQuery(function ($) {
      $('.dt-sc-hotspot-item').each(function () {
        if ($(this).data('hotspot-bound')) return;
        $(this).data('hotspot-bound', true);
        var pop = $(this).find('.dt-sc-hotspot-popup');
        pop.click(function (e) {
          e.stopPropagation();
        });

        $(this).find('a.dt-sc-hotspot-marker').click(function (e) {
          e.preventDefault();
          e.stopPropagation();
          // $(this).parent().addClass('open');          
          // $(this).next('.dt-sc-hotspot-popup').toggleClass('dt-sc-popup-open');
          // $(this).parent().siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');

          $(this).parent().parent().addClass('this-hotspot-in-active');
          // For icons disable 
          if ($(this).hasClass("clicked")) {
            $(this).removeClass("clicked");
            $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css('opacity', '0');
            $(this).css('opacity', '1');
            $('.dt-sc-hotspot-item').removeClass('open');
            $('a.dt-sc-hotspot-marker').css('opacity', '1');
          }
          else {
            $(this).addClass("clicked");
            $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css('opacity', '0');
            $(this).css('opacity', '1');
            $(this).parent().addClass('open');
            $(this).next('.dt-sc-hotspot-popup').toggleClass('dt-sc-popup-open');
            $(this).parent().siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');
          }

          // Disable End

        });

      });
      $(document).off('click.hotspot').on('click.hotspot', function () {
        $('.dt-sc-hotspot-wrapper').removeClass('this-hotspot-in-active');
        $('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');
        $('.dt-sc-hotspot-item').removeClass('open');
        $('a.dt-sc-hotspot-marker').removeClass('clicked').css('opacity', '1');
      });
    });
  }

  if ($(window).width() < 768) {
    $('.dt-sc-hotspot-popup').addClass('mfp-hide');
    $('.dt-sc-hotspot-marker').each(function () {
      if ($(this).data('hotspot-mobile-bound')) return;
      $(this).data('hotspot-mobile-bound', true);
      $(this).magnificPopup({
        type: 'inline',
        closeOnBgClick: true,
        closeBtnInside: false,
        showCloseBtn: true
      });
    });
  }
}


// const node = document.querySelector('div')
// const attributeNodeArray = [...node.attributes];
// const attrs = attributeNodeArray.reduce((attrs, attribute) => {
//   attrs[attribute.name] = attribute.value;
//   return attrs;
// }, {});
// console.log(attrs)


